import React from 'react';
import { makeStyles } from '@mui/styles';
import { AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const useStyles = makeStyles((theme) => ({
  pre: {
    whiteSpace: 'pre-wrap',
  },
  childAccordion: {
    display: 'block',
  },
  headingPost: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: theme.palette.success.main,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const SSOV1 = () => {
  const classes = useStyles();
  return (
    <AccordionDetails className={classes.childAccordion}>
      <Grid
        container
        item
        xs={12}
        spacing={2}
        justifyContent={'space-between'}
      >
        <Grid
          item
          xs={2}
        >
          <h3>Example Response</h3>
        </Grid>
        <Grid
          item
          xs={10}
        >
          <pre className={classes.pre}>
            <code>
              &#123; &quot;success&quot;: true, &quot;url&quot;:
              &quot;https://abc123.dietid.com/#/u/BC123...789XYZ&quot; &#125;
            </code>
          </pre>
        </Grid>
        <Grid
          item
          xs={2}
        >
          <h3>Error Response</h3>
        </Grid>
        <Grid
          item
          xs={10}
        >
          <pre className={classes.pre}>
            <code>
              &#123; &quot;success&quot;: &quot;false&quot;, &quot;message&quot;: &quot;Invalid client secret. Please
              check your Authorization header (Authorization: \&quot;`Bearer xxx\&quot;`)&quot; &#125;
            </code>
          </pre>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};
export default SSOV1;
